//유효기간 날짜 포맷 함수수
const removeUnit = value => {
  // "3m" or "1h"에서 "m" 또는 "h" 제거 후 숫자만 반환
  if (value) {
    return parseInt(value.replace(/[^\d]/gi, ''), 10);
  }
};

export default removeUnit;
